// src/data/forexPairs.js
// Tradeable forex pairs with metadata for position tracking.
// pipSize: decimal movement per pip (0.0001 for most; 0.01 for JPY crosses)

export const FOREX_PAIRS = [
  { ticker: "EURUSD=X", label: "EUR/USD", base: "EUR", quote: "USD", pipSize: 0.0001 },
  { ticker: "GBPUSD=X", label: "GBP/USD", base: "GBP", quote: "USD", pipSize: 0.0001 },
  { ticker: "USDJPY=X", label: "USD/JPY", base: "USD", quote: "JPY", pipSize: 0.01   },
  { ticker: "USDCHF=X", label: "USD/CHF", base: "USD", quote: "CHF", pipSize: 0.0001 },
  { ticker: "AUDUSD=X", label: "AUD/USD", base: "AUD", quote: "USD", pipSize: 0.0001 },
  { ticker: "USDCAD=X", label: "USD/CAD", base: "USD", quote: "CAD", pipSize: 0.0001 },
  { ticker: "NZDUSD=X", label: "NZD/USD", base: "NZD", quote: "USD", pipSize: 0.0001 },
  { ticker: "USDCNH=X", label: "USD/CNH", base: "USD", quote: "CNH", pipSize: 0.0001 },
  { ticker: "EURGBP=X", label: "EUR/GBP", base: "EUR", quote: "GBP", pipSize: 0.0001 },
  { ticker: "EURJPY=X", label: "EUR/JPY", base: "EUR", quote: "JPY", pipSize: 0.01   },
  { ticker: "GBPJPY=X", label: "GBP/JPY", base: "GBP", quote: "JPY", pipSize: 0.01   },
  { ticker: "USDMXN=X", label: "USD/MXN", base: "USD", quote: "MXN", pipSize: 0.0001 },
  { ticker: "USDINR=X", label: "USD/INR", base: "USD", quote: "INR", pipSize: 0.01   },
  { ticker: "USDKRW=X", label: "USD/KRW", base: "USD", quote: "KRW", pipSize: 0.1    },
  { ticker: "USDSEK=X", label: "USD/SEK", base: "USD", quote: "SEK", pipSize: 0.0001 },
  { ticker: "USDNOK=X", label: "USD/NOK", base: "USD", quote: "NOK", pipSize: 0.0001 },
  { ticker: "USDTRY=X", label: "USD/TRY", base: "USD", quote: "TRY", pipSize: 0.001  },
  { ticker: "USDZAR=X", label: "USD/ZAR", base: "USD", quote: "ZAR", pipSize: 0.001  },
];

// Currency → geo-conflict zone IDs for geo-risk integration.
// Exposure is based on the currency's country conflict involvement.
export const FX_CURRENCY_ZONES = {
  EUR: ["ukraine", "georgia"],       // Eurozone — heavily exposed to Ukraine war via sanctions + energy
  GBP: ["ukraine"],                   // UK — Ukraine military aid + sanctions exposure
  JPY: ["northkorea", "taiwan"],     // Japan — regional security threats
  AUD: ["southchina"],               // Australia — South China Sea exposure
  CNH: ["taiwan", "southchina"],     // China — Taiwan strait + South China Sea
  SEK: ["ukraine"],                   // Sweden (new NATO member)
  NOK: ["ukraine"],                   // Norway — significant Ukraine exposure via energy exports
  TRY: ["mideast", "ukraine"],       // Turkey — Middle East + mediator role in Ukraine
  MXN: [],                            // Mexico — low direct geo-risk exposure
  INR: ["pakistan"],                 // India — Pakistan border tensions
  KRW: ["northkorea"],              // South Korea — North Korea threat
  ZAR: [],                            // South Africa — minimal geo-risk
  CHF: [],                            // Switzerland — safe haven, minimal exposure
  CAD: [],                            // Canada — minimal geo-risk
  NZD: [],                            // New Zealand — minimal geo-risk
  USD: [],                            // USD — global reserve, not zone-specific
};

/**
 * Get pip size for a pair ticker.
 * @param {string} ticker — Yahoo Finance ticker e.g. "EURUSD=X"
 */
export function getPipSize(ticker) {
  return FOREX_PAIRS.find(p => p.ticker === ticker)?.pipSize ?? 0.0001;
}

/**
 * Get pair metadata by ticker.
 */
export function getPairMeta(ticker) {
  return FOREX_PAIRS.find(p => p.ticker === ticker) ?? { ticker, label: ticker, base: "USD", quote: "USD", pipSize: 0.0001 };
}
